import React from 'react';

export default function AdminLogo() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 300">
        <path
          d="M65.3,181.66v55.62a5.29,5.29,0,0,0,9.52,3.17L102,204.23l8.28-4.24L200,73.2l1.66-9.86-14.57,8L65.28,177.1Z"
          fill="#fe9923"
        />
        <path
          d="M196.18,62.49c-.24.1-170,85.35-170.26,85.46a5.3,5.3,0,0,0-.41,9.24L65.3,181.67,201.61,63.35h0A5.13,5.13,0,0,0,196.18,62.49Z"
          fill="#fedb41"
        />
        <path
          d="M201.8,63.6c-.08-.07-.11-.19-.19-.26l-1,1.47L102,204.23l61,37.55a5.29,5.29,0,0,0,8-3.53L203.41,68.33A5.25,5.25,0,0,0,201.8,63.6Z"
          fill="#fc3"
        />
      </svg>
    </>
  );
}
